<template>
    <Head :title="translate('registration.teaser:headlines').join(' ')" />
    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('registration.teaser:headlines')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <RegistrationBox :nft="nft"></RegistrationBox>
            </div>
        </div>
        <Steps :step="2"></Steps>
    </div>
    <!--LatestNfts></LatestNfts>
    <FAQ></FAQ-->
</template>

<script>
import FAQ from './../../../Components/FAQ';
import RegistrationBox from './../../../Components/Auth/RegistrationBox';
import Steps from "../../../Components/Steps";
import LatestNfts from "../../../Components/LatestNfts";
import {Head, usePage} from '@inertiajs/inertia-vue3'
import Teaser from "../../../Components/Common/Teaser";
import translate from "../../../../lang";

export default {
    components: {
        Teaser,
        LatestNfts,
        Steps,
        FAQ,
        RegistrationBox,
        Head,
    },
    props: {
        nft: Object,
    },
    setup() {
        return {
            translate: translate('upload-' + usePage().props.value.metaDataType.type),
        }
    }
}
</script>
